module.exports = __webpack_public_path__ + "img/wolf_bg_mob.9622571d.jpg";